(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["champion-events-calendar"]) return;
  try {
    
(() => {
  const text = value => value == null ? '' : String(value);
  const equal = (a,b) => text(a).toLowerCase() === text(b).toLowerCase();
  const key = date => `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  const matches = (record,event,date) => record.date === date && (record.eventId ? record.eventId === event.eventId : equal(record.gameSystem,event.gameSystem) && equal(record.name,event.name) && equal(record.time,event.time));
  const todayAtStore = () => {
    const parts = new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date());
    const value = type => Number(parts.find(part => part.type === type).value);
    return new Date(value('year'),value('month')-1,value('day'));
  };
  const element = (tag,cls,value) => {const node=document.createElement(tag);node.className=cls;if(value!=null)node.textContent=value;return node;};
  const safeImage = url => {try {return new URL(url).protocol === 'https:';} catch (_) {return false;}};
  const registrationLink = value => {try {const url=new URL(text(value));return ['https:','http:'].includes(url.protocol) ? url.href : '';} catch (_) {return '';}};
  function render(calendar,schedule,today) {
    const months=calendar.querySelector('[data-event-months]');months.replaceChildren();
    const first=new Date(today.getFullYear(),today.getMonth(),1);
    const visible=[first];if(today.getDate()>15)visible.push(new Date(first.getFullYear(),first.getMonth()+1,1));
    let count=0;
    visible.forEach(month=>{
      const section=element('section','ch-events__month');
      const heading=element('header','ch-events__heading');
      heading.appendChild(element('h2','',month.toLocaleDateString('en-US',{month:'long',year:'numeric'})));section.appendChild(heading);
      const scroll=element('div','ch-events__scroll');scroll.tabIndex=0;scroll.setAttribute('aria-label','Scrollable monthly events calendar');
      const grid=element('div','ch-events__grid');grid.setAttribute('role','table');
      ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'].forEach(day=>{const cell=element('div','ch-events__weekday',day);cell.setAttribute('role','columnheader');grid.appendChild(cell);});
      const days=new Date(month.getFullYear(),month.getMonth()+1,0).getDate();
      const cells=Math.ceil((month.getDay()+days)/7)*7;
      for(let index=0;index<cells;index++){
        const day=index-month.getDay()+1;const cell=element('div','ch-events__day');cell.setAttribute('role','cell');
        if(day<1||day>days){cell.classList.add('ch-events__day--outside');cell.textContent='\u00a0';cell.setAttribute('aria-hidden','true');grid.appendChild(cell);continue;}
        const date=new Date(month.getFullYear(),month.getMonth(),day);const dateKey=key(date);
        cell.appendChild(element('span','ch-events__date',day));
        const events=(schedule.events||[]).filter(event=>(event.isOneTime?event.date===dateKey:event.day===date.getDay())&&!(schedule.exclusions||[]).some(record=>matches(record,event,dateKey)))
          .sort((a,b)=>(a.sortTime-b.sortTime)||text(a.name).localeCompare(text(b.name),'en',{sensitivity:'base'}));
        events.forEach(event=>{
          count++;const link=registrationLink(event.registrationUrl);const card=element(link?'a':'div','ch-events__card');
          if(link){card.href=link;card.setAttribute('aria-label',`Register for ${text(event.name)||text(event.gameSystem)}${event.format?' - '+text(event.format):''} on ${dateKey}${event.time?' at '+text(event.time):''}`);}
          if(safeImage(event.iconUrl)){const icon=element('img','ch-events__icon');icon.src=event.iconUrl;icon.alt=`${text(event.gameSystem)} logo`;icon.loading='lazy';card.appendChild(icon);}
          else card.appendChild(element('span','ch-events__system',event.gameSystem));
          let label=text(event.name);
          if(equal(event.gameSystem,'Magic')){
            label=text(event.format);
            if(!event.isOneTime&&equal(label.trim(),'*Varies Weekly*')){
              const overrides=(schedule.overrides||[]).filter(record=>matches(record,event,dateKey));label=overrides.length?text(overrides[overrides.length-1].format):'TBD';
            }
          }
          if(label.trim())card.appendChild(element('span','ch-events__name',label));
          if(text(event.time).trim())card.appendChild(element('span','ch-events__time',text(event.time).trim().replaceAll(' & ','\n& ')));
          cell.appendChild(card);
        });
        grid.appendChild(cell);
      }
      scroll.appendChild(grid);section.appendChild(scroll);months.appendChild(section);
    });
    calendar.querySelector('[data-event-empty]').hidden=count!==0;
  }
  function initialize(){document.querySelectorAll('[data-events-calendar]:not([data-ready])').forEach(calendar=>{
    let schedule;try{schedule=JSON.parse(calendar.dataset.schedule||'{}')||{};}catch(_){return;}
    calendar.dataset.ready='true';let current=key(todayAtStore());render(calendar,schedule,todayAtStore());
    const timer=setInterval(()=>{if(!calendar.isConnected){clearInterval(timer);return;}const today=todayAtStore();if(key(today)!==current){current=key(today);render(calendar,schedule,today);}},60000);
  });}
  initialize();document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["champion-homepage"] && !Shopify.designMode) return;
  try {
    
  const initializeChampionEvents = (scope = document) => {
    scope.querySelectorAll('[data-ch-event-list]').forEach((eventList) => {
      const cards = [...eventList.querySelectorAll('[data-ch-event-card]')];
      if (!cards.length) return;
      const timeZone = eventList.dataset.chTimeZone || 'America/New_York';
      const dayName = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone }).format(new Date());
      const weekdays = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      const currentWeekday = weekdays[dayName];
      if (currentWeekday === undefined) return;
      cards
        .sort((firstCard, secondCard) => {
          const firstOffset = (Number(firstCard.dataset.chEventWeekday) - currentWeekday + 7) % 7;
          const secondOffset = (Number(secondCard.dataset.chEventWeekday) - currentWeekday + 7) % 7;
          return firstOffset - secondOffset;
        })
        .forEach((card, index) => {
          card.hidden = index >= 3;
          eventList.append(card);
        });
    });
  };
  const initializeBannerDayCarousels = (scope = document) => {
    scope.querySelectorAll('[data-banner-day-carousel]').forEach((carousel) => {
      if (carousel.dataset.bannerDayInitialized === 'true') return;
      carousel.dataset.bannerDayInitialized = 'true';
      const section = carousel.closest('[data-banner-day-section]');
      const slideHost = carousel.querySelector('[data-banner-day-slides]');
      const controls = carousel.querySelector('[data-banner-day-controls]');
      const dotHost = carousel.querySelector('[data-banner-day-dots]');
      const scheduleNode = carousel.querySelector('[data-banner-day-schedule]');
      const previousButton = carousel.querySelector('[data-ch-slide-previous]');
      const nextButton = carousel.querySelector('[data-ch-slide-next]');
      const pauseButton = carousel.querySelector('[data-ch-slide-pause]');
      if (!section || !slideHost || !controls || !dotHost || !scheduleNode || !previousButton || !nextButton || !pauseButton) return;

      let schedule;
      try {
        schedule = JSON.parse(scheduleNode.textContent || '{}');
      } catch (error) {
        schedule = {};
      }
      const scheduledSlides = Array.isArray(schedule.slides) ? schedule.slides : [];
      let slides = [];
      let dots = [];
      let activeIndex = 0;
      let rotationTimer;
      let boundaryTimer;
      let playing = carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const speed = Number(carousel.dataset.speed) || 7000;

      const safeLink = (value) => {
        if (typeof value !== 'string') return '';
        const trimmed = value.trim();
        if (/^\/(?!\/)/.test(trimmed)) return trimmed;
        try {
          const parsed = new URL(trimmed);
          return parsed.protocol === 'https:' ? parsed.href : '';
        } catch (error) {
          return '';
        }
      };
      const safeImage = (value) => {
        if (typeof value !== 'string') return '';
        try {
          const parsed = new URL(value.trim());
          return parsed.protocol === 'https:' ? parsed.href : '';
        } catch (error) {
          return '';
        }
      };
      const asTime = (value) => {
        const result = typeof value === 'string' && value ? Date.parse(value) : Number.NaN;
        return Number.isFinite(result) ? result : null;
      };
      const isActive = (slide, now) => {
        if (!slide || slide.enabled === false || !safeImage(slide.desktopImageUrl)) return false;
        const start = asTime(slide.startUtc);
        const end = asTime(slide.endUtc);
        return (start === null || start <= now) && (end === null || end > now);
      };
      const orderedActiveSlides = (now) => scheduledSlides
        .filter((slide) => isActive(slide, now))
        .sort((first, second) => (Number(first.displayOrder) || 0) - (Number(second.displayOrder) || 0));

      const createSlide = (value, index) => {
        const article = document.createElement('article');
        article.className = 'ch-home__featured-slide' + (index === 0 ? ' is-active' : '');
        article.dataset.chFeaturedSlide = '';
        article.dataset.bannerDaySlideId = typeof value.id === 'string' ? value.id : '';
        article.setAttribute('aria-hidden', String(index !== 0));

        const link = safeLink(value.link);
        const media = document.createElement(link ? 'a' : 'div');
        media.className = 'ch-home__featured-media';
        if (link) media.href = link;
        const picture = document.createElement('picture');
        const mobileImage = safeImage(value.mobileImageUrl);
        if (mobileImage) {
          const source = document.createElement('source');
          source.media = '(max-width: 760px)';
          source.srcset = mobileImage;
          picture.append(source);
        }
        const image = document.createElement('img');
        image.src = safeImage(value.desktopImageUrl);
        image.alt = typeof value.altText === 'string' ? value.altText : '';
        image.loading = index === 0 ? 'eager' : 'lazy';
        image.fetchPriority = index === 0 ? 'high' : 'auto';
        image.decoding = 'async';
        image.width = 1600;
        image.height = 1000;
        picture.append(image);
        media.append(picture);
        article.append(media);

        const copy = document.createElement('div');
        copy.className = 'ch-home__featured-copy';
        if (value.eyebrow) {
          const eyebrow = document.createElement('p');
          eyebrow.className = 'ch-home__eyebrow ch-home__eyebrow--gold';
          eyebrow.textContent = value.eyebrow;
          copy.append(eyebrow);
        }
        if (value.heading) {
          const heading = document.createElement('h2');
          heading.textContent = value.heading;
          copy.append(heading);
        }
        if (value.description) {
          const description = document.createElement('p');
          description.textContent = value.description;
          copy.append(description);
        }
        if (value.buttonLabel && link) {
          const buttons = document.createElement('div');
          buttons.className = 'ch-home__buttons';
          const button = document.createElement('a');
          button.className = 'ch-home__button ch-home__button--light';
          button.href = link;
          button.textContent = value.buttonLabel;
          buttons.append(button);
          copy.append(buttons);
        }
        article.append(copy);
        return article;
      };

      const showSlide = (nextIndex) => {
        if (!slides.length) return;
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      };
      const startRotation = () => {
        window.clearInterval(rotationTimer);
        if (playing && slides.length > 1) rotationTimer = window.setInterval(() => showSlide(activeIndex + 1), speed);
      };
      const scheduleBoundaryRefresh = (now) => {
        window.clearTimeout(boundaryTimer);
        const boundaries = scheduledSlides
          .flatMap((slide) => [asTime(slide.startUtc), asTime(slide.endUtc)])
          .filter((value) => value !== null && value > now)
          .sort((first, second) => first - second);
        if (!boundaries.length) return;
        boundaryTimer = window.setTimeout(() => {
          if (carousel.isConnected) render();
        }, Math.min(boundaries[0] - now + 250, 2147483647));
      };
      const render = () => {
        const now = Date.now();
        const activeSlides = orderedActiveSlides(now);
        const defaultSlide = schedule.defaultSlide && safeImage(schedule.defaultSlide.desktopImageUrl)
          ? schedule.defaultSlide
          : null;
        const visibleSlides = activeSlides.length ? activeSlides : (defaultSlide ? [defaultSlide] : []);
        window.clearInterval(rotationTimer);
        const expectedIds = visibleSlides.map((value) => typeof value.id === 'string' ? value.id : '');
        const renderedIds = [...slideHost.querySelectorAll('[data-ch-featured-slide]')]
          .map((slide) => slide.dataset.bannerDaySlideId || '');
        const matchesServerRender = expectedIds.length === renderedIds.length &&
          expectedIds.every((value, index) => value === renderedIds[index]);
        if (!matchesServerRender) {
          slideHost.replaceChildren();
          visibleSlides.forEach((value, index) => slideHost.append(createSlide(value, index)));
        }
        dotHost.replaceChildren();
        activeIndex = 0;
        slides = [...slideHost.querySelectorAll('[data-ch-featured-slide]')];
        showSlide(0);
        slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.className = 'ch-home__slide-dot' + (index === 0 ? ' is-active' : '');
          dot.type = 'button';
          dot.dataset.chSlideDot = String(index);
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-selected', String(index === 0));
          dot.setAttribute('aria-label', `Show slide ${index + 1}`);
          dot.addEventListener('click', () => { showSlide(index); startRotation(); });
          dotHost.append(dot);
        });
        dots = [...dotHost.querySelectorAll('[data-ch-slide-dot]')];
        section.hidden = slides.length === 0;
        controls.hidden = slides.length < 2;
        startRotation();
        scheduleBoundaryRefresh(now);
      };

      previousButton.addEventListener('click', () => { showSlide(activeIndex - 1); startRotation(); });
      nextButton.addEventListener('click', () => { showSlide(activeIndex + 1); startRotation(); });
      pauseButton.addEventListener('click', () => {
        playing = !playing;
        pauseButton.textContent = playing ? 'Ⅱ' : '▶';
        pauseButton.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
        startRotation();
      });
      render();
    });
  };
  initializeChampionEvents();
  initializeBannerDayCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    initializeChampionEvents(event.target);
    initializeBannerDayCarousels(event.target);
  });

  const initializeFreshFinds = (root = document) => {
    root.querySelectorAll('[data-fresh-grid]').forEach((grid) => {
      if (grid.dataset.freshInitialized) return;
      grid.dataset.freshInitialized = 'true';
      const pages = Number(grid.dataset.freshPages) || 1;
      if (pages <= 1) return;
      const load = async () => {
        const cards = new Map([...grid.querySelectorAll('[data-fresh-id]')].map(card => [card.dataset.freshId, card]));
        const pageNumbers = Array.from({ length: pages }, (_, index) => index + 1)
          .filter(page => page !== Number(grid.dataset.freshPage));
        const fetchPage = async (page) => {
          const url = new URL(window.location.pathname, window.location.origin);
          url.searchParams.set('section_id', grid.dataset.freshSection);
          url.searchParams.set(grid.dataset.freshPageParam || 'page', String(page));
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Fresh finds request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const pageGrid = doc.querySelector('[data-fresh-grid]');
          if (!pageGrid || Number(pageGrid.dataset.freshPage) !== page) throw new Error('Fresh finds page mismatch');
          pageGrid.querySelectorAll('[data-fresh-id]').forEach(card => cards.set(card.dataset.freshId, card));
        };
        try {
          for (let index = 0; index < pageNumbers.length; index += 3) {
            await Promise.all(pageNumbers.slice(index, index + 3).map(fetchPage));
          }
          const newest = [...cards.values()].sort((left, right) =>
            Number(right.dataset.freshTime) - Number(left.dataset.freshTime) ||
            right.dataset.freshId.localeCompare(left.dataset.freshId)).slice(0, 5);
          if (grid.isConnected) {
            grid.replaceChildren(...newest.map(card => document.importNode(card, true)));
            grid.dataset.freshLoad = 'complete';
          }
        } catch (error) {
          grid.dataset.freshLoad = 'incomplete';
        }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            observer.disconnect();
            load();
          }
        }, { rootMargin: '800px' });
        observer.observe(grid);
      } else {
        load();
      }
    });
  };
  initializeFreshFinds();
  document.addEventListener('shopify:section:load', event => initializeFreshFinds(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["champion-upcoming-releases"]) return;
  try {
    
  (() => {
    const monthNames = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const text = (value) => value == null ? '' : String(value);
    const parseDate = (value) => {
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(text(value));
      return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
    };
    const monthKey = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    const addMonth = (date, amount) => new Date(date.getFullYear(), date.getMonth() + amount, 1);

    document.querySelectorAll('[data-release-calendar]:not([data-ready])').forEach((calendar) => {
      calendar.dataset.ready = 'true';
      let releases = [];
      try {
        const parsed = JSON.parse(calendar.dataset.releases || '[]');
        if (Array.isArray(parsed)) releases = parsed;
      } catch (_) {}

      const today = new Date();
      const current = new Date(today.getFullYear(), today.getMonth(), 1);
      const visibleMonths = [current];
      if (today.getDate() > 15) visibleMonths.push(addMonth(current, 1));
      const byMonth = new Map();
      releases.forEach((release) => {
        const date = parseDate(release.date);
        if (!date) return;
        const key = monthKey(date);
        if (!byMonth.has(key)) byMonth.set(key, []);
        byMonth.get(key).push({ ...release, parsedDate: date });
      });

      const months = calendar.querySelector('[data-release-months]');
      let visibleReleaseCount = 0;
      visibleMonths.forEach((first) => {
        const monthReleases = byMonth.get(monthKey(first)) || [];
        visibleReleaseCount += monthReleases.length;
        const section = document.createElement('section');
        section.className = 'ch-releases__month';
        const heading = document.createElement('h2');
        heading.className = 'ch-releases__month-title';
        heading.textContent = monthNames.format(first);
        section.appendChild(heading);
        const scroll = document.createElement('div');
        scroll.className = 'ch-releases__scroll';
        const grid = document.createElement('div');
        grid.className = 'ch-releases__grid';
        grid.setAttribute('role', 'grid');
        weekdays.forEach((weekday) => {
          const label = document.createElement('div');
          label.className = 'ch-releases__weekday';
          label.setAttribute('role', 'columnheader');
          label.textContent = weekday;
          grid.appendChild(label);
        });
        for (let blank = 0; blank < first.getDay(); blank += 1) {
          const cell = document.createElement('div');
          cell.className = 'ch-releases__day ch-releases__day--outside';
          cell.setAttribute('role', 'gridcell');
          cell.setAttribute('aria-hidden', 'true');
          cell.textContent = '\u00a0';
          grid.appendChild(cell);
        }
        const days = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
        for (let day = 1; day <= days; day += 1) {
          const cell = document.createElement('div');
          cell.className = 'ch-releases__day';
          cell.setAttribute('role', 'gridcell');
          const number = document.createElement('span');
          number.className = 'ch-releases__date';
          number.textContent = day;
          cell.appendChild(number);
          monthReleases.filter((release) => release.parsedDate.getDate() === day).forEach((release) => {
            const details = document.createElement('details');
            details.className = 'ch-releases__item';
            const summary = document.createElement('summary');
            summary.className = 'ch-releases__summary';
            summary.title = text(release.description);
            if (release.iconUrl) {
              const image = document.createElement('img');
              image.className = 'ch-releases__icon';
              image.src = text(release.iconUrl);
              image.alt = `${text(release.gameSystem)} logo`;
              image.loading = 'lazy';
              summary.appendChild(image);
            } else {
              const system = document.createElement('span');
              system.className = 'ch-releases__system';
              system.textContent = text(release.gameSystem);
              summary.appendChild(system);
            }
            const name = document.createElement('span');
            name.className = 'ch-releases__name';
            name.textContent = text(release.name);
            summary.appendChild(name);
            const description = document.createElement('div');
            description.className = 'ch-releases__description';
            description.textContent = text(release.description);
            details.append(summary, description);
            cell.appendChild(details);
          });
          grid.appendChild(cell);
        }
        while ((grid.children.length - 7) % 7 !== 0) {
          const cell = document.createElement('div');
          cell.className = 'ch-releases__day ch-releases__day--outside';
          cell.setAttribute('role', 'gridcell');
          cell.setAttribute('aria-hidden', 'true');
          cell.textContent = '\u00a0';
          grid.appendChild(cell);
        }
        scroll.appendChild(grid);
        section.appendChild(scroll);
        months.appendChild(section);
      });
      calendar.querySelector('[data-release-empty]').hidden = visibleReleaseCount !== 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
